// 主区 EmptyState —— 未选中任何 Room 时显示

import { useI18n } from "../lib/i18n";

export function EmptyState() {
  const { t } = useI18n();
  return (
    <section className="empty-state">
      <h2>{t("empty.pick")}</h2>
      <p className="muted">
        <code>#/rooms/&lt;name&gt;</code>
      </p>
    </section>
  );
}
